module.exports = __webpack_public_path__ + "static/assets/64faeccd0a42a3548ec41b7471ff5ef6.svg";